// extracted by mini-css-extract-plugin
export default {"fr-view":"Finder_fr-view__kC1Wy","folders":"Finder_folders__Bx2D5","isDraggingOver":"Finder_isDraggingOver__2qZaY","margin-bottom":"Finder_margin-bottom__P1Nbi"};